var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('icu-button',{on:{"click":function($event){_vm.files = []}}},[_vm._v(" Clear ")]),_c('validation-provider',{attrs:{"rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('icu-dropzone',{attrs:{"maximum-files":100,"value":_vm.files,"errors":errors},on:{"input":_vm.addFile}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }